import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import Global from '../../../../Services/Common/Global';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { WOR_DAI_02_Schema } from './WOR_DAI_02_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';

/** 사업장 관리자 + 총괄관리자 조회 GetManager */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(WOR_DAI_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['WorkInfo', 'getManager', params],
    queryFn: () => apiRequest('post', Global.urls.Utility.getManager, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 작업 종료 조회 GetWoeBasicR1 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(WOR_DAI_02_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.WorkEnd.getWoeBasicR1, params);
  }, successOptions);
};

/** 안전신문고 저장 SaveAccBasic02U1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, WOR_DAI_02_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.WorkInfo.saveAccBasic02U1, payload);
  }, options);
};

/** 작업 종료 저장 SaveWoeBasicU1 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, WOR_DAI_02_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.WorkEnd.saveWoeBasicU1, payload);
  }, options);
};
